<template>
  <div>
    <div class="appearance" v-if="false">
      <h6 @click="togglePanel">{{onlineUsers.length}}</h6>
      <!--<div class="content" v-if="!closed">
        <router-link :to="{ name: 'UserSingle', params: { id: user.to_param }}" v-for="user in onlineUsers" :key="user.to_param">
          {{user.nickname}}
        </router-link>

        <div v-if="onlineTeams.length">
          <hr>
          <h4>times online</h4>
          <router-link :to="{ name: 'TeamSingle', params: { id: team.to_param }}" v-for="team in onlineTeams" :key="team.to_param">
            {{team.name}}
          </router-link>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Chat",
  props: {
    msg: String
  },
  data: function() {
    return {
      cable: null,
      onlineUsers: [],
      onlineTeams: [],
      closed: true
    };
  },
  methods: {
    reloadOnlineUsers() {
      var self = this;
      this.$http.get("pages/online_users.json").then(response => {
        self.onlineUsers = response.data.users;
        self.onlineTeams = response.data.teams;
      });
    },
    togglePanel() {
      this.closed = !this.closed;
    },
    initialize: function() {
      var self = this;
      this.subscription = this.$cable.subscriptions.create(
        { channel: "AppearanceChannel" },
        {
          received: function(data) {
            // self.reloadOnlineUsers()
          }
        }
      );

      window.addEventListener(
        "beforeunload",
        function(event) {
          self.subscription.unsubscribe();
        },
        false
      );

      self.reloadOnlineUsers();
    }
  },
  mounted() {
    this.initialize();
  },
  components: {}
};
</script>

<style scoped>
.appearance {
  position: fixed;
  bottom: 0;
  right: 0px;
  font-size: 9px;
  padding: 4px 4px 0 6px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 5;
}
.appearance h6 {
  cursor: pointer;
  line-height: 100%;
  margin: 0;
  font-weight: normal;
  font-size: 12px;
}

.content {
  font-size: 13px;
  padding: 8px;
}

.content a {
  display: block;
}
</style>
